import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "../../Assets/css/home.css";
import { isMobile, isMobileOnly } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { base_url, postHeader } from "../../../../Helpers/request";
import { useState } from "react";
import { toast } from "react-toastify";
import banneImg from '../../../../Assets/images/oro-img/banner-home.webp'
import banneImgMobile from '../../../../Assets/images/oro-img/banner-home-mobile.webp'

const BannerSlider = () => {
  const history = useHistory();
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //-----------------------------------Banner
    setLoading(true);
    axios
      .get(base_url + `/home/slider`, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setLoading(false);
          setBanner(response.data.data);
          localStorage.setItem(
            "bw-bannerdata",
            JSON.stringify(response.data.data)
          );
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (

    <>
    <Container className="showcase-container">
      {!loading ? (
        banner?.map((val, index) => (
          <div
          
            className="rcs_hero_slider"
            style={{
              margin: "0px" ,
              backgroundImage: `url(${
                // isMobileOnly ? val?.mobile_image : val?.image
                  isMobileOnly ? banneImgMobile : banneImg
              })`,
            }}
          >
            {/* <img src={isMobileOnly ? banneImgMobile : banneImg}/> */}
            <div className="rcs_hero_img">
              <Container fluid>
                <Row className="m-auto w-100">
                  <Col xs={12}  sm={12}  md={{span: 6, offset:1}}  lg={{span: 6, offset:1}} className="p-0">
                    {val.btn_text === "" ? (
                      ""
                    ) : (
                      <div
                        className={`${
                          isMobileOnly ? "text-center" : val.text_direction_class
                        } text-left`}
                      >
                        <h1 >
                          {/* {val.title} */}
                          The beginning of a <br></br>
beautiful forever
                        </h1>
                        <p>
                          {/* {val.short_text} */}
                          Explore the latest Engagement ring collection
                        </p>
                        <Button
                          onClick={() => {
                            history.push("/" + val.btn_link);
                          }}
                          className="outline-base-btn large  text-upper-case"
                        >
                          {val.btn_text}
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        ))
      ) : (
        <div className="sk" style={{ margin: "0" }}>
          <Skeleton variant="text" animation="wave" height={"90vh"} />
        </div>
      )}
        </Container>
    </>
  );
};

export default BannerSlider;
